import { Component, Inject, NgZone, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import * as _ from 'lodash';

import { AppService } from 'src/app/app.service';
import { EntityService } from 'src/app/_core/entity.service';

@Component({
    selector: 'app-authorizenet-pay-dialog',
    templateUrl: './authorizenet-pay-dialog.component.html',
    styleUrls: ['./authorizenet-pay-dialog.component.scss'],
    standalone: false
})
export class AuthorizenetPayDialogComponent implements AfterViewInit {

	trustedIframeUrl: SafeResourceUrl;
    authorizeNetURL: string;

	constructor(
		private zone: NgZone,
		private sanitizer: DomSanitizer,
		public appService: AppService,
		public entityService: EntityService,
		public dialogRef: MatDialogRef<AuthorizenetPayDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.trustedIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.redirectURL);
        this.authorizeNetURL = this.data.iframeUrl || this.appService.appConfig.authorizeNetURL;
	}

	ngAfterViewInit() {
		const sendToken = document.getElementById('send_token') as HTMLFormElement;
		if (sendToken) {
			sendToken.setAttribute('action', this.authorizeNetURL);
			sendToken.setAttribute('target', 'add_payment');
			sendToken.submit();
		}
		let that = this;
		
		if (!window["AuthorizeNetIFrame"]) window["AuthorizeNetIFrame"] = {};
		window["AuthorizeNetIFrame"].onReceiveCommunication = function (querystr) {
			console.log('Message from auth.net', querystr);

			var params = parseQueryString(querystr);
			switch (params["action"]) {
				case "successfulSave":
					break;
				case "cancel":
					that.zone.run(_ => {
						that.dialogRef.close({ mode: "cancel" });
					});
					
					break;
				case "resizeWindow":
					var h = parseInt(params["height"]);
					var ifrm = document.getElementById("add_payment");
					//ifrm.style.width = w.toString() + "px";
					ifrm.style.height = h.toString() + "px";
					break;
				case "transactResponse":
					that.zone.run(_ => {
						let response: any = JSON.parse(params["response"]);
						console.log(params, response);
						if (response && response.transId) {
							that.dialogRef.close({ mode: "success", transactionId: response.transId, billTo: response.billTo });
						} else {
							that.appService.alert({ content: "MESSAGES.EX_PAYMENT_ERROR" }).then(() => {
								that.dialogRef.close({ mode: "cancel" });
							});
						}						
					});					
					break;
			}

			function parseQueryString(str) {
				var vars = [];
				var arr = str.split('&');
				var pair;
				for (var i = 0; i < arr.length; i++) {
					pair = arr[i].split('=');
					vars.push(pair[0]);
					vars[pair[0]] = unescape(pair[1]);
				}
				return vars;
			}
		};

	}

}

